module.exports = __webpack_public_path__ + "img/wenhao.8f5002ea.png";